'use client';

import { useEffect, useRef, useState } from 'react';

import { useElementObserver } from '@core/Hooks/UseElementObserver';

import { LeasingVehicleAttributes } from 'Components/LeasingVehicleAttributes/LeasingVehicleAttributes';

import { LeasingLeadCTAs } from '../LeasingLeadCTAs/LeasingLeadCTAs';
import type { LeasingStickyInfoProps } from './LeasingStickyInfo.entity';

import styles from '../StickyInfo/StickyInfo.module.css';

export const LeasingStickyInfo = ({
  locale,
  strings: { pdpStrings, vehicleAttributesStrings },
  vehicle,
}: LeasingStickyInfoProps) => {
  const $stickyInfo = useRef<HTMLDivElement>(null);

  const [isSticky, setIsSticky] = useState(false);

  useElementObserver($stickyInfo, entry => {
    const contentBoxSize = entry.contentBoxSize[0];
    const height = contentBoxSize.blockSize;
    const root = document.querySelector(':root') as HTMLElement;

    if (window.scrollY > 80 && window.innerWidth > 1023) {
      root.style.setProperty('--sticky-info-height', `${height}px`);
    } else {
      root.style.removeProperty('--sticky-info-height');
    }
  });

  // Scroll event for UspsItems condition
  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 80 && window.innerWidth > 1023);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <div ref={$stickyInfo} className={`${styles.stickyInfo} ${isSticky ? styles.sticky : ''}`}>
        <LeasingVehicleAttributes
          strings={vehicleAttributesStrings}
          locale={locale}
          vehicle={vehicle}
        />
        <LeasingLeadCTAs vehicle={vehicle} strings={pdpStrings} />
      </div>
      <div
        ref={$stickyInfo}
        className={`${styles.stickyInfoCompact} ${isSticky ? styles.sticky : ''}`}
      >
        <LeasingVehicleAttributes
          strings={vehicleAttributesStrings}
          locale={locale}
          vehicle={vehicle}
        />
        <LeasingLeadCTAs vehicle={vehicle} strings={pdpStrings} />
      </div>
    </>
  );
};

LeasingStickyInfo.displayName = 'LeasingStickyInfo';
